import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "blog" }
const _hoisted_2 = { id: "blog-content" }
const _hoisted_3 = { id: "blog-nav" }
const _hoisted_4 = { id: "blog-article" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t("pages.Blog.pageTitle")), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("h2", null, "Articles", -1)),
        _createElementVNode("ol", null, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/blog/July4th2022" }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("July4th2022", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/blog/July5th2022" }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("July5th2022", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/blog/things" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("pages.Things.pageTitle")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("article", _hoisted_4, [
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}